/**
 * Invoice email activity items carry the addresses the email went to, so the
 * log still shows who was emailed after the customer's contacts have changed.
 */
export const getRecipients = (metadata: unknown): string[] => {
  if (!metadata || typeof metadata !== 'object') return []

  const recipients = (metadata as Record<string, unknown>).recipients
  if (!Array.isArray(recipients)) return []

  return recipients.filter(
    (recipient): recipient is string =>
      typeof recipient === 'string' && recipient.trim() !== ''
  )
}
